<template>
    <Breadcrumb>
        <BreadcrumbItem 
            v-for="(item,index) in breadcrumbs"
            :key="index"
            :to="item" >{{item.title}}</BreadcrumbItem>
    </Breadcrumb>
</template>
<script>
import router from '@/router'
    export default {
        name:'breadcrumb',
        data(){
            return{
                breadcrumbs:[]
            }
        },
        mounted(){
            this.initBreadCrumbs();
        },
        methods:{
            /**
            *面包屑
            *
            */     
            initBreadCrumbs() {
                let routeMatch = this.$route.matched;
                this.breadcrumbs = [];            
                for (let i = 0; i < routeMatch.length; i++) {
                    if (routeMatch[i].meta && routeMatch[i].meta.title && routeMatch[i].meta.name!='') {

                        let obj={
                            name:routeMatch[i].name,
                            title:routeMatch[i].meta.name,
                            params:this.$route.params
                        }
                        this.breadcrumbs.push(obj);
                    }
                }
            },

        },
        watch:{
            $route(){
                this.initBreadCrumbs();
            }
        }
    }
</script>

<style scoped>

</style>
